import React, { Fragment } from 'react';

/**
 * This Component creates Header (with main and additional text) for every page
 */
const CommonHeader = props => {

    const {
        headerText,
        additionalElement,
        additionalElementClassName,
        additionalElementStyle,
        additionalText,
        pageName
    } = props;

    return (
        <Fragment>
            <div className="grid-row">
                <h1 data-gtmvalue={pageName} className="mobile:grid-col-12 tablet:grid-col-fill">
                    {headerText}
                    {
                        additionalText &&
                        <span className='header-additional-text'>
                            {additionalText}
                        </span>
                    }

                </h1>
                {
                    additionalElement && (
                        <span
                            className={additionalElementClassName}
                            style={additionalElementStyle}
                        >
                            {additionalElement}
                        </span>
                    )
                }
            </div>
        </Fragment>
    );
};

export default CommonHeader;